<script>
import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import VueSweetalert2 from 'vue-sweetalert2'

Vue.use(VueSweetalert2)
Vue.use(BootstrapVue)
export default {
  directives: {
    Ripple,
  },
  props: [
    // eslint-disable-next-line vue/require-prop-types
    'paramsGrid',
  ],
  data() {
    return {
      selected: [],
      // currentPage: 1,
      rows: 0,
      // showEntrie: 10,
      // totalElements: 0,
      // entries: [10, 20, 50, 100],
      dataSource: [],
      // optionFilter: {
      //   column: null,
      // },
      filters: {
        id: '',
        tienda: '',
        marca: '',
        perfil: '',
        fechaCreacion: '',
        fechaEdit: '',
      },
    }
  },
  mounted() {
    this.loadDataSource()
  },
  methods: {
    limpiarOtrosFiltros(exceptKey) {
      for (let i = 0; i < this.paramsGrid.fields.length; i += 1) {
        if (this.paramsGrid.fields[i].key !== exceptKey) {
          this.paramsGrid.filters[this.paramsGrid.fields[i].key] = ''
        }
      }
    },
    // filterColumn(field) {
    //   if (this.paramsGrid.filters[field.key].trim() !== '') {
    //     this.optionFilter.column = field.key
    //     this.limpiarOtrosFiltros(field.key)
    //   } else {
    //     this.optionFilter.column = null
    //   }
    //   this.loadDataSource()
    // },
    async deleteItem(item) {
      this.$swal({
        title: 'Está seguro que desea eliminar el registro?',
        text: '',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, eliminar!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const request = {
            url: `${this.paramsGrid.delete.ruta}/${item.id}`,
            method: 'DELETE',
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
          try {
            store.dispatch('back/EXECUTE', request).then(r => {
              if (r.success) {
                this.$swal({
                  icon: 'success',
                  title: 'Eliminado!',
                  text: 'El registro fue eliminado.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.loadDataSource()
              }
            })
            // verificar la respuesta y alertar
          } catch (e) {
            console.log(e.message)
          }
        }
      })
    },
    // cambioPagina(e) {
    //   this.currentPage = e
    //   this.loadDataSource()
    // },
    // changeSizePage() {
    //   this.loadDataSource()
    // },
    async loadDataSource() {
      const url = this.paramsGrid.urlBack
      // url += `limit=${this.showEntrie}&page=${this.currentPage}`
      // if (this.optionFilter.column) {
      //   url += `&contains=${this.optionFilter.column}&value=${this.paramsGrid.filters[this.optionFilter.column]}`
      // }
      const request = {
        url,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
      const respRoles = await store.dispatch('back/EXECUTE', request)
      console.log('respRoles', respRoles)
      this.dataSource = respRoles
      // this.totalElements = respRoles.responseFilter.total_rows
      this.rows = respRoles
      // this.showEntrie = respRoles.responseFilter.limit
    },
    editElement(item) {
      if (this.paramsGrid.edit.redirect) {
        this.$router.push(`${this.paramsGrid.edit.ruta}/${item.id}`)
      } else {
        this.$children[3].showModal()
      }
    },
    onRowSelected(items) {
      this.selected = items
    },
  },
}
</script>

<template>
  <div>
    <b-row class="mb-1">
      <b-col sm="9" />
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-table
          show-empty
          selectable
          :select-mode="'single'"
          responsive
          empty-text="No matching records found"
          :items="dataSource"
          :fields="paramsGrid.fields"
          @row-selected="onRowSelected"
        >
          <!-- <template slot="top-row">
            <td
              v-for="field in paramsGrid.fields"
              :key="field.key"
            >
              <input
                v-if="!field.key.includes('actions') && !field.key.includes('row')"
                v-model="paramsGrid.filters[field.key]"
                class="form-control form-control-sm"
                :placeholder="field.label"
                @change="filterColumn(field)"
              >
            </td>
          </template> -->
          <template #cell(row)="data">
            <div style="width:0px !important;">
              <b-form-checkbox
                :checked="selected.includes(data.item)"
              />
            </div>
          </template>
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <feather-icon
                v-if="paramsGrid.edit.available"
                :id="`invoice-row-${data.item.id}-preview-icon`"
                icon="PenToolIcon"
                size="16"
                class="mx-1"
                @click="editElement(data.item)"
              />
              <b-tooltip
                title="Editar"
                placement="left"
                :target="`invoice-row-${data.item.id}-preview-icon`"
              />
              <feather-icon
                v-if="paramsGrid.delete.available"
                :id="`invoice-row-${data.item.id}-delete-icon`"
                icon="Trash2Icon"
                size="16"
                class="mx-1"
                @click="deleteItem(data.item)"
              />
              <b-tooltip
                title="Eliminar"
                placement="right"
                :target="`invoice-row-${data.item.id}-delete-icon`"
              />
            </div>
          </template>
          <template #cell()="data">
            <span class="text-nowrap">{{ data.value }}</span>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <!-- <b-row v-if="paramsGrid.pagination">
      <b-col sm="3">
        <b-form-group
          label-cols="4"
          label-cols-md="4"
          label-size="md"
          label="Entradas:"
          label-for="input-md"
        >
          <b-form-select
            v-model="showEntrie"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="entries"
            @change="changeSizePage"
          />
        </b-form-group>
      </b-col>
      <b-col
        sm="3"
        class="mt-75"
        style="font-size:12px"
      >
        <span> {{ totalElements }} Registros en total</span>
      </b-col>
      <b-col
        sm="6"
        style="text-align: right;"
      >
        <b-pagination
          v-model="currentPage"
          :per-page="showEntrie"
          :total-rows="20"
          :align="'right'"
          @change="cambioPagina"
        />
      </b-col>
    </b-row> -->
  </div>
</template>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.invoice-filter-select {
  min-width: 190px;
  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }
  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>
<style lang="scss">

</style>
